import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
// import reportWebVitals from "./reportWebVitals";
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./rootReducer";
import { Provider } from "react-redux";

// CRA overlay turns plain rejected objects into `new Error(obj)` → "[object Object]".
// Normalize / swallow SDK rejections (ZIM etc.) so the app stays usable.
window.addEventListener("unhandledrejection", (event) => {
  const reason = event.reason;
  if (!reason || reason instanceof Error || typeof reason === "string") return;
  if (typeof reason !== "object") return;
  event.preventDefault();
  const r = reason as { message?: unknown; msg?: unknown; code?: unknown };
  const msg =
    (typeof r.message === "string" && r.message) ||
    (typeof r.msg === "string" && r.msg) ||
    (r.code != null ? `Request failed (code ${r.code})` : null) ||
    (() => {
      try {
        return JSON.stringify(reason);
      } catch {
        return "Unknown promise rejection";
      }
    })();
  console.warn("[unhandledrejection]", msg, reason);
});

const store = configureStore({
  reducer: rootReducer,
});

export type IRootState = ReturnType<typeof store.getState>;

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
